// extracted by mini-css-extract-plugin
export default {"dot":"ActiveDot_dot__BiWF3","active":"ActiveDot_active__bOzkI","inactive":"ActiveDot_inactive__onL7E"};